module.exports = __webpack_public_path__ + "static/img/coe_bg.ff865342.png";